import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IExamResultTypeModel extends IModel {
  examResultTypeId: number;
  name: string;
}

export class ExamResultTypeModel
  extends Model
  implements ModelRecord<IExamResultTypeModel>
{
  examResultTypeId: number;
  name: string;

  constructor(params?: Partial<IExamResultTypeModel>) {
    super(params);
    this.examResultTypeId = defaultTo(params?.examResultTypeId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
